<template>
  <div
    class="w-fit flex items-center text-neutral-500 bg-gray-200 px-2 py-0.5 rounded-full overflow-hidden min-h-fit"
  >
    <div v-if="messageData" class="flex items-center">
      <img
        v-if="isSvgIcon"
        :src="systemTypes[messageType]"
        alt="icon"
        class="w-4 h-4 mt-0.5"
      />
      <span
        v-else
        class="material-symbols-outlined text-[16px]"
        :class="messageType === 'forward' ? 'scale-x-[-100%]' : ''"
      >
        {{ systemTypes[messageType] }}
      </span>
      <span class="material-symbols-outlined text-[16px]">arrow_right</span>
    </div>
    <div class="flex items-center gap-1 h-5 overflow-hidden">
      <div
        class="system-message-content text-ellipsis text-xs"
        v-html="messageContent"
      />
      <template v-if="messageData">
        <span class="w-4 h-4 flex items-center justify-center">•</span>
        <span
          v-tooltip="{
            content: getStatusTimes,
            html: true,
          }"
          dir="ltr"
          class="text-xs cursor-pointer email-time has-status-icon whitespace-nowrap flex-1"
        >
          {{ readableTime }}
        </span>
      </template>
    </div>
  </div>
</template>
<script>
import timeMixin from 'dashboard/mixins/time';
import agentIcon from 'dashboard/assets/images/agent.svg';
import botIcon from 'dashboard/assets/images/bot.svg';

export default {
  mixins: [timeMixin],
  props: {
    messageContent: {
      type: String,
      required: true,
    },
    messageData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      systemTypes: {
        resolved: 'check_circle',
        blocked: 'do_not_disturb_on',
        unblocked: 'lock_open_right',
        pending: 'pending',
        unassigned: 'person_remove',
        assigned: 'person_add',
        removed: 'delete',
        priority: 'label_important',
        forward: 'reply',
        tag: 'shoppingmode',
        reopened: agentIcon,
      },
      activityKeywords: [
        ['unblocked', ['unblocked', 'ביטל חסימת']], // before 'blocked'
        ['unassigned', ['unassigned', 'בוטל השיוך']], // before 'assigned'
        ['resolved', ['resolved', 'טופל']],
        ['pending', ['pending', 'ידני']],
        ['blocked', ['blocked']], // HE muted is untranslated
        ['assigned', ['assigned', 'שויך', 'שייך']], // שייך = self-assigned in HE
        ['priority', ['priority', 'תעדוף', 'עדיפות']], // before 'removed': EN "removed the priority" contains 'removed'
        ['removed', ['removed the priority', 'הסיר את העדיפות']],
        ['forward', ['forwarded', 'העביר']],
        ['reopened', ['reopened', 'למצב פתוח']],
        ['tag', ['added', 'removed', 'הוסיף', 'הסיר']],
      ],
      agentIcon,
      botIcon,
    };
  },
  computed: {
    isSvgIcon() {
      if (['reopened'].includes(this.messageType)) return true;
      return false;
    },
    messageType() {
      const content = this.messageContent.toLowerCase();
      const match = this.activityKeywords.find(([, keywords]) =>
        keywords.some(kw => content.includes(kw))
      );
      return match ? match[0] : 'resolved';
    },
    readableTime() {
      return this.messageStampFull(
        this.messageData.created_at,
        'HH:mm | dd/MM/yy'
      );
    },
    getStatusTimes() {
      return Object.entries(this.messageData.status_history)
        .reduce((acc, [status, time]) => {
          return acc.concat(
            `<div><span style="text-transform: capitalize">

              ${this.$t(
                `CAMPAIGN.MESSAGE_STATUS.${status.toUpperCase()}`
              )}</span>: &nbsp;<span>${this.messageStampFull(
                time,
                'HH:mm | dd/MM/yy'
              )}</span></div>`
          );
        }, [])
        .join('');
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .system-message-content {
    p {
      margin: 0;
      font-size: 12px;
    }
    a {
      font-size: 12px;
    }
  }
}
</style>
